import { SVGProps } from "react";

const Save = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3 6.4C3 4.52223 4.52223 3 6.4 3H11.5H13.8438C14.5201 3 15.1687 3.26866 15.6469 3.74688L19.2531 7.35312C19.7313 7.83134 20 8.47994 20 9.15624V11.5V16.6C20 18.4778 18.4778 20 16.6 20H6.4C4.52223 20 3 18.4778 3 16.6V6.4Z"
      stroke="currentColor"
      strokeWidth={1.275}
    />
    <path
      d="M6.39844 14.0496C6.39844 13.1107 7.15955 12.3496 8.09844 12.3496H14.8984C15.8373 12.3496 16.5984 13.1107 16.5984 14.0496V19.9996H6.39844V14.0496Z"
      stroke="currentColor"
      strokeWidth={1.275}
    />
    <path
      d="M8.10156 3V6.4C8.10156 6.86944 8.48212 7.25 8.95156 7.25H14.0516C14.521 7.25 14.9016 6.86944 14.9016 6.4V3"
      stroke="currentColor"
      strokeWidth={1.275}
    />
  </svg>
);
export default Save;
